import {
    CheckCircle2,
    FolderInput,
    Copy,
    FolderPlus,
    FolderMinus,
    Download,
    Trash2,
    X
} from "lucide-react";

export default function BulkToolbar({

    selectedCount,
    currentListId,

    onMove,
    onCopy,
    onRemove,
    onAdd,
    onDownload,
    onDelete,
    onClear

}){

    return(

        <div className="bulk-toolbar">

            <div className="bulk-count">

                <CheckCircle2 size={18}/>

                <span>

                    {selectedCount} Selected

                </span>

            </div>

            <div className="bulk-actions">

                <button onClick={onMove}>

                    <FolderInput size={16}/>

                    Move

                </button>

                <button onClick={onCopy}>

                    <Copy size={16}/>

                    Copy

                </button>

                {

                    currentListId

                    ?

                    <button onClick={onRemove}>

                        <FolderMinus size={16}/>

                        Remove

                    </button>

                    :

                    <button onClick={onAdd}>

                        <FolderPlus size={16}/>

                        Add To List

                    </button>

                }

                <button onClick={onDownload}>

                    <Download size={16}/>

                    Download

                </button>

                {

                    !currentListId &&

                    <button

                        className="danger"

                        onClick={onDelete}

                    >

                        <Trash2 size={16}/>

                        Delete

                    </button>

                }

                <button onClick={onClear}>

                    <X size={16}/>

                    Clear

                </button>

            </div>

            <style>{`

.bulk-toolbar{

    display:flex;

    justify-content:space-between;

    align-items:center;

    flex-wrap:wrap;

    gap:16px;

    padding:14px 18px;

    margin-bottom:20px;

    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:16px;

    box-shadow:
        0 1px 2px rgba(15,23,42,.05);

}

.bulk-count{

    display:flex;

    align-items:center;

    gap:10px;

    font-size:15px;

    font-weight:600;

    color:#2563EB;

}

.bulk-actions{

    display:flex;

    flex-wrap:wrap;

    gap:10px;

}

.bulk-actions button{

    height:40px;

    padding:0 16px;

    border:none;

    border-radius:10px;

    background:#F8FAFC;

    color:#334155;

    font-size:14px;

    font-weight:500;

    display:flex;

    align-items:center;

    gap:8px;

    cursor:pointer;

    transition:all .18s ease;

}

.bulk-actions button svg{

    color:#64748B;

}

.bulk-actions button:hover{

    background:#EEF4FF;

    transform:translateY(-1px);

}

.bulk-actions button:hover svg{

    color:#2563EB;

}

.bulk-actions .danger{

    background:#FEF2F2;

    color:#DC2626;

}

.bulk-actions .danger svg{

    color:#DC2626;

}

.bulk-actions .danger:hover{

    background:#FEE2E2;

}

@media(max-width:768px){

    .bulk-toolbar{

        align-items:flex-start;

    }

    .bulk-actions{

        width:100%;

    }

}

`}</style>

        </div>

    );

}